import React from 'react';
import { SvgIconProps } from '../types';

export default function Location({
  fill,
  width,
  height,
  className,
  ariaLabel,
  ariaHidden,
}: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 34 34"
      fill="none"
      width={width}
      height={height}
      className={className}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    >
      <path
        d="M17.0009 0.849976C10.6739 0.849976 5.52539 6.1189 5.52539 12.5962C5.52539 15.2296 7.30323 19.5654 10.8102 25.4849C13.3589 29.7862 15.9444 33.4268 15.9698 33.463C16.2097 33.8003 16.5928 34 17.0004 34C17.4078 34 17.7905 33.8003 18.0305 33.463C18.0563 33.427 20.6419 29.786 23.1906 25.4849C26.697 19.5662 28.4754 15.2304 28.4754 12.5962C28.4754 6.11917 23.3281 0.849976 17.0005 0.849976H17.0009ZM17.0009 30.4408C13.8014 25.7363 8.07572 16.5063 8.07572 12.5955C8.07572 7.55832 12.0797 3.45981 17.0009 3.45981C21.9223 3.45981 25.9261 7.55819 25.9261 12.5955C25.9258 16.5041 20.1998 25.7355 17.0015 30.4408H17.0009ZM17.0009 6.06964C13.4856 6.06964 10.626 8.99675 10.626 12.5949C10.6262 16.1931 13.4856 19.121 17.0009 19.121C20.5162 19.121 23.3761 16.1937 23.3761 12.5955C23.3761 8.99728 20.5159 6.06964 17.0009 6.06964V6.06964ZM17.0009 16.5103C14.8915 16.5103 13.1759 14.7537 13.1759 12.5951C13.1759 10.4364 14.8915 8.67987 17.0009 8.67987C19.1098 8.67987 20.8259 10.4364 20.8259 12.5951C20.8259 14.7537 19.1098 16.5103 17.0009 16.5103Z"
        fill={fill}
      />
    </svg>
  );
}